@if (showHeader) {
<h2>
  Noticeboard @if (k2Only) {
  <small>
    <i class="iconfont lock"></i>
    notes only visible to K2
  </small>
  }
</h2>
} @if (title) {
<h2>
  {{ title }}
</h2>
}

<markdown-editor
  [id]="'markdown-editor'"
  [(value)]="_notes"
  [placeholder]="placeholder"
  [noPreview]="true"
  (valueChange)="onNotesChange($event)"
></markdown-editor>

<btn (click)="save.emit(notes)" icon="check2">Save changes</btn>
